<h1 class="mb-4"> <mdb-icon fas icon="cog"></mdb-icon> Vendedores Clientes </h1> <!-- Heading -->
<div class="card card-miga-pan mb-2 wow"> <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Vendedores Clientes</span>
    </p>
  </div>
</div> <!-- Heading --> <!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row mb-2 filtros-body">
        <div class="col-2 " style="max-width: 200px;"> <!-- Material checked -->
          <div class="form-check"> <input type="radio" class="form-check-input" id="rbVistaCliente" mdbInput
              formControlName="tipoVista" [value]="RB_TIPO_VISTA_CLIENTE" /> <label class="form-check-label"
              for="rbVistaCliente">Vista Clientes</label> </div>
          <div class="form-check"> <input type="radio" class="form-check-input" id="rbVistaClienteProducto" mdbInput
              formControlName="tipoVista" [value]="RB_TIPO_VISTA_CLIENTE_PRODUCTO" /> <label class="form-check-label"
              for="rbVistaClienteProducto">Vista Cliente Producto</label> </div> <!-- Material unchecked -->
          <div class="form-check"> <input type="radio" class="form-check-input" id="rbVistaProducto" mdbInput
              formControlName="tipoVista" [value]="RB_TIPO_VISTA_PRODUCTO" /> <label class="form-check-label"
              for="rbVistaProducto">Vista Producto</label> </div>
        </div>
        <div class="col" style="max-width: 140px">
          <div class="md-form mb-0"> <mdb-date-picker [inline]="true" label="" name="fechaDesde" [placeholder]="'Desde'"
              formControlName="fechaDesde" required></mdb-date-picker>
            <div
              *ngIf="formHeader.get('fechaDesde').invalid && (formHeader.get('fechaDesde').dirty || formHeader.get('fechaDesde').touched)">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde </mdb-error>
            </div>
            <div *ngIf="formHeader.errors.fechaIngreso" style="padding-top: 25%;">
              <mdb-error>El intervalo de fechas no puede ser mayor a 12 meses.</mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 140px">
          <div class="md-form mb-0"> <mdb-date-picker [inline]="true" label="" name="fechaHasta" [placeholder]="'Hasta'"
              formControlName="fechaHasta" required></mdb-date-picker>
            <div
              *ngIf="formHeader.get('fechaHasta').invalid && (formHeader.get('fechaHasta').dirty || formHeader.get('fechaHasta').touched)">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form"> <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true"
              [highlightFirst]="false" placeholder="Seleccione" formControlName="listaVendedor"></mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
        <div class="col d-flex align-items-center" style="max-width: 400px"> <strong>Buscar por Cliente: </strong>
          <!-- Material inline 1 --> <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccion()"> <mdb-icon fas icon="search"></mdb-icon> </button> <ng-container> <button
              mdbBtn type="button" size="sm" class="btn btn-sm" color="info" mdbWavesEffect
              [ngClass]="{'enabledContent': true}" (click)="abrirModalSeleccionarClienteSeleccionados()"
              *ngIf="clientesSeleccionados?.length > 0"> ({{clientesSeleccionados.length | numerico}}) Seleccionados
            </button> </ng-container> </div>
        <div class="col d-flex align-items-center" style="max-width: 400px"> <strong>Buscar por Producto: </strong>
          <!-- Material inline 1 --> <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarProducto()"> <mdb-icon fas icon="search"></mdb-icon> </button>
          <h6 class="text-info" *ngIf="productosMultiplesSeleccionados?.length > 1" style="display: contents;"> <button
              mdbBtn type="button" size="sm" class="btn btn-sm" color="info" mdbWavesEffect
              (click)="abrirModalSeleccionarProductosSeleccionados()"> ({{productosMultiplesSeleccionados.length |
              numerico}}) Seleccionados </button> </h6>
          <h6 class="text-info" *ngIf="productosMultiplesSeleccionados?.length === 1" style="display: contents;"> {{
            productosMultiplesSeleccionados[0].descripcion }} </h6>
        </div>
        <div class="col">
          <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE"> <mdb-checkbox
              formControlName="cliente_con_venta">Clientes con venta</mdb-checkbox> </div>
          <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE"> <mdb-checkbox
              formControlName="cliente_sin_venta">Clientes sin venta</mdb-checkbox> </div>
          <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE_PRODUCTO"> <mdb-checkbox
              formControlName="producto_sin_sku">Incluir producto sin SKU</mdb-checkbox> </div>
          <div
            *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE || formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE_PRODUCTO">
            <mdb-checkbox formControlName="incl_cliente_inactivos">Incluir Clientes Inactivos</mdb-checkbox>
          </div>
        </div>
      </div>
    </div> <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE" mdbBtn type="button"
          color="secondary" size="sm" mdbWavesEffect (click)="clienteBuscar(1)"
          [disabled]="formHeader.errors.fechaIngreso === true"><mdb-icon fas icon="search"></mdb-icon>Buscar</button>
        <button *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE_PRODUCTO" mdbBtn type="button"
          color="secondary" size="sm" mdbWavesEffect (click)="clienteProductoBuscarNotificacion()"
          [disabled]="formHeader.errors.fechaIngreso === true"><mdb-icon fas icon="search"></mdb-icon>Buscar</button>
        <button *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_PRODUCTO" mdbBtn type="button"
          color="secondary" size="sm" mdbWavesEffect (click)="productoBuscarNotificacion()"
          [disabled]="formHeader.errors.fechaIngreso === true"><mdb-icon fas icon="search"></mdb-icon>Buscar</button>
      </div>
    </div>

  </div>
</form> <!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="cliente_loading || cliente_producto_loading || producto_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="cliente_loading || cliente_producto_loading || producto_loading"
        spinnerColor="blue"></mdb-spinner>
    </div>
    <div class="table-responsive"
      *ngIf="!cliente_loading && formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE">
      <table class="table table-striped table-hover table-sm align-middle"
        *ngIf="!cliente_loading && cliente_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">Dirección</th>
            <th scope="col">Ciudad</th>
            <th scope="col">Comuna</th>
            <th scope="col">Territ.</th>
            <th scope="col">Vendedor</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descto.</th>
            <th scope="col" class="text-right">Total Neto</th>
            <th scope="col">Cant. Clientes</th>
            <th scope="col">F. Ingresos</th>
            <!-- <th scope="col" class="text-right">Últ. Vta</th>             <th scope="col" class="text-right">Días s/vta</th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center"
              *ngIf="!cliente_loading && cliente_listaMovimientos?.length === 0"> No se encontró información </td>
          </tr>
          <tr *ngFor="let mov of cliente_listaMovimientos">
            <td>{{ mov.rutFormato | rut }}</td>
            <td>{{ mov.cliente_proveedor_nombre }}</td>
            <td>{{ mov.direccion_nombre }}</td>
            <td>{{ mov.nombreprovincia }}</td>
            <td>{{ mov.nombrecomuna }}</td>
            <td>{{ mov.territorio_codigo }}</td>
            <td>{{ mov.nombre }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
            <td>{{ mov.cantClienteVend === 0 ? "" : mov.cantClienteVend }}</td>
            <td>{{ mov.fecha_ingreso_cliente | fecha }}</td>
            <!-- <td class="text-right">{{ mov.monto_ultima_venta | numerico }}</td>
              <td class="text-right">{{ mov.dia_sin_venta | numerico }}</td> -->
          </tr>
        </tbody>
        <tbody class="blue lighten-5" *ngIf="!cliente_loading && cliente_listaMovimientos?.length !== 0">
          <tr>
            <td colspan="6" class="text-right"><strong></strong></td>
            <!-- <td class="text-right">               <span><strong>Cantidad Clien.: </strong></span>
              <span>{{cliente_totales.cantidad_cliente | numerico}}</span>             </td> -->
            <td class="text-right"><strong>Totales</strong></td>
            <td class="text-right">$ {{cliente_totales.monto_neto_cliente | numerico}}</td>
            <td class="text-right">$ {{cliente_totales.descuento_cliente | numerico}}</td>
            <td class="text-right">$ {{cliente_totales.neto_total_cliente | numerico}}</td>
            <td class="text-right"></td>
            <td class="text-right"></td>
          </tr>
        </tbody> <app-pagination [context]="cliente_paginationContext" (onPageChange)="clienteOnPageChange($event)"
          *ngIf="cliente_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <div
      *ngIf="!cliente_producto_loading && cliente_producto_listaMovimientos?.length === 0 && formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE_PRODUCTO"
      #alert class="alert alert-info alert-dismissible fade show m-0" role="alert">
      <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>Se ha enviado la solicitud!</strong> En breve minutos llegara la notificacion para descagar el reporte.
    </div>
    <div class="table-responsive"
      *ngIf="!cliente_producto_loading && formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE_PRODUCTO && cliente_producto_listaMovimientos?.length !== 0">
      <table class="table table-striped table-hover table-sm align-middle"
        *ngIf="!cliente_producto_loading && cliente_producto_listaMovimientos">
        <thead class="grey lighten-2">
          <tr> <!-- <th scope="col">Código</th> -->
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">SKU</th>
            <th scope="col">Descripción</th>
            <th scope="col">Formato</th>
            <th scope="col" class="text-right">Cantidad</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="text-right">Total Neto</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Fecha</th> <!-- <th scope="col"></th>             <th scope="col"></th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center"
              *ngIf="!cliente_producto_loading && cliente_producto_listaMovimientos?.length === 0"> No se encontró
              información </td>
          </tr>
          <tr *ngFor="let mov of cliente_producto_listaMovimientos"> <!-- <td>{{ mov.codigo }}</td> -->
            <td>{{ mov.rutFormato | rut }}</td>
            <td>{{ mov.cliente_proveedor_nombre }}</td>
            <td>{{ mov.sku }}</td>
            <td>{{ mov.producto_nombre }}</td>
            <td>{{ mov.formato_nombre }}</td>
            <td class="text-right">{{ mov.cantidad | numerico }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
            <td>{{ mov.nombre }}</td>
            <td>{{ mov.fecha_ult_venta | fecha }}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5"
          *ngIf="!cliente_producto_loading && cliente_producto_listaMovimientos?.length !== 0">
          <tr>
            <td colspan="5" class="text-right"><strong></strong></td>
            <!-- <td class="text-right"><span><strong>Cantidad Clien.:</strong></span><span> {{producto_totales.cantidad_producto | numerico}}</span></td> -->
            <td class="text-right"><strong>Totales</strong></td>
            <td class="text-right">$ {{cliente_producto_totales.monto_neto_producto | numerico}}</td>
            <td class="text-right">$ {{cliente_producto_totales.descuento_producto | numerico}}</td>
            <td class="text-right">$ {{cliente_producto_totales.neto_total_producto | numerico}}</td>
            <td class="text-right"></td>
            <td class="text-right"></td>
          </tr>
        </tbody> <app-pagination [context]="cliente_producto_paginationContext"
          (onPageChange)="clienteProductoOnPageChange($event)"
          *ngIf="cliente_producto_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <div
      *ngIf="!producto_loading && producto_listaMovimientos?.length === 0 && formHeader.get('tipoVista').value === RB_TIPO_VISTA_PRODUCTO"
      #alert class="alert alert-info alert-dismissible fade show m-0" role="alert">
      <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>Se ha enviado la solicitud!</strong> En breve minutos llegara la notificacion para descagar el reporte.
    </div>
    <div class="table-responsive"
      *ngIf="!producto_loading && formHeader.get('tipoVista').value === RB_TIPO_VISTA_PRODUCTO && producto_listaMovimientos?.length !== 0">
      <table class="table table-striped table-hover table-sm align-middle"
        *ngIf="!producto_loading && producto_listaMovimientos">
        <thead class="grey lighten-2">
          <tr> <!-- <th scope="col">Código</th> -->
            <th scope="col">SKU</th>
            <th scope="col">Descripción</th>
            <th scope="col">Formato</th>
            <th scope="col" class="text-right">Cantidad</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="text-right">Total Neto</th>
            <!-- <th scope="col"></th>             <th scope="col"></th> -->
          </tr>
        </thead>
        <tbody *ngFor="let listaDev of producto_listaMovimientos">
          <tr>
            <td colspan="100%" style="text-align: center"
              *ngIf="!producto_loading && producto_listaMovimientos?.length === 0"> No se encontró información </td>
          </tr>
          <tr class="grey lighten-3">
            <td colspan="6" style="font-weight: bold;"> <b
                *ngIf="formHeader.get('listaVendedor').value.length > 0">{{listaDev.vendedor_nombre}}</b> <b
                *ngIf="formHeader.get('listaVendedor').value.length === 0">{{listaDev.familia_nombre}}</b> </td>
            <td><b></b></td>
          </tr>
          <tr *ngFor="let mov of listaDev.producto_groupItem">
            <td>{{ mov.sku }}</td>
            <td>{{ mov.producto_nombre }}</td>
            <td>{{ mov.formato_nombre }}</td>
            <td class="text-right">{{ mov.cantidad | numerico }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5" *ngIf="!producto_loading && producto_listaMovimientos?.length !== 0">
          <tr>
            <td colspan="2" class="text-right"><strong></strong></td>
            <!-- <td class="text-right"><span><strong>Cantidad Clien.:</strong></span><span> {{producto_totales.cantidad_producto | numerico}}</span></td> -->
            <td class="text-right"><strong>Totales</strong></td>
            <td class="text-right"> {{producto_totales.cantidad_producto | numerico}}</td>
            <td class="text-right">$ {{producto_totales.monto_neto_producto | numerico}}</td>
            <td class="text-right">$ {{producto_totales.descuento_producto | numerico}}</td>
            <td class="text-right">$ {{producto_totales.neto_total_producto | numerico}}</td>
          </tr>
        </tbody> <app-pagination [context]="producto_paginationContext" (onPageChange)="productoOnPageChange($event)"
          *ngIf="producto_groupArr?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE && cliente_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end"> <button size="sm" mdbBtn type="button" color="success"
      mdbWavesEffect class="btn btn-sm" (click)="clienteDownloadExcelPdf('XLS')"> Excel </button> </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_CLIENTE_PRODUCTO && cliente_producto_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end"> <button size="sm" mdbBtn type="button" color="success"
      mdbWavesEffect class="btn btn-sm" (click)="clienteProductoDownloadExcelPdf('XLS')"> Excel </button> </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_PRODUCTO && producto_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end"> <button size="sm" mdbBtn type="button" color="success"
      mdbWavesEffect class="btn btn-sm" (click)="productoDownloadExcelPdf('XLS')"> Excel </button> </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto (onSelect)="onProductoSeleccionado($event)" [showFiltroActivoInactivo]="false"
  (onNotFound)="onProductoNoEncontrado()" showSelectAll="true" (onSelectAll)="onMultiplesProductosSeleccionados($event)"
  paginateLocally="true" (onUncheckProducto)="uncheckProducto($event)"> </app-modal-seleccionar-producto>
<app-modal-show-clientes></app-modal-show-clientes>
